 <template>
  <el-container>
    <el-main class="login-user__main">
      <el-row class="login-user__main-row">
        <!-- Left part -->
        <el-col v-if="!isMobile" class="login-user__main-row__left" :span="12">
          <el-image style="width: 100%; height: 100%;" :src="require('@/assets/LandingPage/landing-page-3@2x.png')"
            fit="cover"></el-image>
          <div class="login-user__main-row__left__content">
            <el-row type="flex" justify="center" align="middle" style="flex-direction: column;"
              class="login-user__main-row__left__content__row">
              <el-col class="login-user__main-row__left__content__first-row mb-5">
                <p>
                  Automate  &amp; Secure Your Credentials
                </p>
              </el-col>
              <el-col class="mb-5">
                <LoginUserLeftIconAndDescription :url="require('@/assets/Login/certificate.svg')"
                  description="A better approach to issue and manage official documents / certificates " />
              </el-col>
              <el-col class="mb-5">
                <LoginUserLeftIconAndDescription :url="require('@/assets/Login/phone.svg')"
                  description="Issue secured &amp; tamper proof certificates using blockchain technology" />
              </el-col>
              <el-col>
                <LoginUserLeftIconAndDescription :url="require('@/assets/Login/scan.svg')"
                  description="Prove your certificate's authenticity with a simple QR code scan!" />
              </el-col>
            </el-row>
          </div>
        </el-col>
        <!-- Right Part -->
        <el-col class="login-user__main-row__right" :span="!isMobile ? 12 : 24">
          <el-row type="flex" justify="center" align="middle" class="login-user__main-row__right__content-wrapper">
            <el-col class="login-user__main-row__right__content">
              <el-row>
                <el-col class="pb-5">
                  <el-row @click.native="$router.push({ name: 'Home' })" style="cursor: pointer;" type="flex"
                    justify="center" align="middle">
                    <el-image style="width: 262; height:100px;" :src="require('@/assets/LandingPage/logo.png')"
                      fit="scale-down"></el-image>
                  </el-row>
                </el-col>
                <el-col class="px-4">
                  <el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="top"
                    label-width="100px">
                    <el-row v-if="sessionTimeout === '1'" class="mb-5">
                      <el-col>
                        <el-alert title="Session timeout" type="error"
                          description="You have been logged out due to inactivity" show-icon>
                        </el-alert>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>
                        <el-form-item prop="username">
                          <el-input placeholder="Username or E-mail" name="username" type="search"
                            v-model="loginForm.username" class="d-custom-textfield-auth"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <el-row type="flex">
                          <el-col class="pr-1">
                            <el-form-item prop="password">
                              <el-input placeholder="Password" name="password" type="password"
                                @keyup.enter.native="handleLogin" v-model="loginForm.password"
                                class="d-custom-textfield-auth"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-form-item>
                            <el-button round :loading="loginLoading" @click.native.prevent="handleLogin"
                              class="d-custom-login-button" type="primary">Sign in</el-button>
                          </el-form-item>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-form>
                </el-col>

                <el-col class="login-user__main-row__right__content__forgot-password mb-4">
                  <p @click="$router.push({ name: 'forgot-password' })" class="login-label-button">
                    Forgot Password
                  </p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
    <el-footer class="login-user__footer">
      <el-row class="login-user__footer__contents" type="flex" justify="center" align="middle">
        <a @click="$router.push('privacy-policy')">Privacy Policy</a>
        <p>© {{ currentYear }} NanoVerify</p>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
/* eslint-disable */
import LoginUserLeftIconAndDescription from "@/components/Login/LoginUserLeftIconAndDescription.vue";
import isMobileMixin from "@/mixins/isMobileMixin.js";

export default {
  name: "Login",
  components: {
    LoginUserLeftIconAndDescription
  },
  mixins: [isMobileMixin],
  beforeCreate() {
    const { jwt } = this.$route.query;
    if (jwt) {
      this.$store.commit("SET_TOKEN", jwt);
      this.$router.replace({ name: "Home" });
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please fill in the password"));
      } else {
        if (this.signupForm.confirmPassword !== "") {
          this.$refs.signupForm.validateField("confirmPassword");
        }
        callback();
      }
    };

    return {
      currentYear: new Date().getFullYear(),
      loginForm: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [
          {
            required: true,
            trigger: "blur",
            message: "Please fill in your username or e-mail address"
          }
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: "Please fill in your password"
          }
        ]
      },
      loginLoading: false,
      signupForm: {
        email: "",
        password: "",
        confirmPassword: ""
      },
      signupRules: {
        email: [
          {
            required: true,
            message: "Please fill in your email address",
            trigger: "blur"
          },
          {
            type: "email",
            message: "Please input correct email address",
            trigger: ["blur", "change"]
          }
        ],
        password: [
          {
            required: true,
            message: "Please fill in your password",
            trigger: "blur"
          },
          {
            min: 8,
            message: "Password must be at least 8 characters",
            trigger: "blur"
          },
          { validator: validatePass, trigger: "blur" }
        ]
      },
      signupLoading: false
    };
  },
  computed: {
    sessionTimeout() {
      return this.$route.query.timeout;
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loginLoading = true;
          try {
            this.$store
              .dispatch("LoginUser", this.loginForm)
              .then(data => {
                this.loginLoading = false;
                this.$router.replace({ name: "Home" });
              })
              .catch(() => {
                this.loginLoading = false;
              });
          } catch (error) {
            console.error(error);
          } finally {
            this.loginLoading = false;
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login-user__main {
  height: 100px;
  padding: 0px;
  min-height: calc(100vh - 48px);

  .login-user__main-row {
    height: 100%;

    .login-user__main-row__left {
      height: 100%;
      position: relative;

      .login-user__main-row__left__content {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
        background-image: linear-gradient(270deg,
            rgba(255, 255, 255, 0.04) 0%,
            rgba(4, 138, 191, 0.57) 0%,
            #023373 100%);

        // background-image: linear-gradient(181deg, rgba(255,255,255,1) 0%, rgba(179,110,110,0.57) 0%, rgba(121,0,0,1) 100%);
        .login-user__main-row__left__content__row {
          height: 100%;
          width: 100%;
          max-width: 393px;
          padding: 8px;
          margin: auto;

          .login-user__main-row__left__content__first-row {
            font-size: 20px;
            font-weight: bold;
            line-height: 1.25;
            text-align: left;
            color: #ffffff;
          }
        }
      }
    }

    .login-user__main-row__right {
      height: 100%;

      .login-user__main-row__right__content-wrapper {
        height: 100%;

        .login-user__main-row__right__content {
          max-width: 388px;

          .d-custom-login-button {
            color: white !important;
            background-color: #bf2c47;
            border-color: #bf2c47;
            width: 134px;

            span {
              font-size: 14px;
              font-weight: normal;
            }
          }

          .d-custom-login-button__outline {
            color: #707070 !important;
            background-color: white;
            border: solid 3px #bf2c47;
            font-size: 14px;
            font-weight: normal;
            width: 134px;
            box-sizing: border-box;
            padding-top: 9px;
            padding-bottom: 9px;

            span {
              color: #bf2c47;
              font-size: 14px;
              font-weight: normal;
            }
          }

          .login-user__main-row__right__content__forgot-password {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }

  .login-horizontal-line {
    width: 100%;
    height: 1px;
    background-color: #707070;
  }

  .login-label {
    font-size: 15px;
    line-height: 1.13;
    color: #707070;
  }

  .login-label-button {
    cursor: pointer;
    font-size: 15px;
    line-height: 1.13;
    color: #707070;

    &:hover {
      color: #504f4f;
    }
  }
}

.recaptcha-texts {
  padding: 0 4px;
  font-size: 12px;
  color: #00000050;
  text-align: justify;

  a {
    color: blue;
    cursor: pointer;
  }
}

.login-user__footer {
  height: 48px !important;
  background-color: #f8f8f8;

  .login-user__footer__contents {
    height: 100%;
    padding: 0 15px;

    a {
      cursor: pointer;
      line-height: 1.17;
      font-size: 12px;
      color: #b2b2b2;
      margin: 15px;
    }

    p {
      cursor: pointer;
      line-height: 1.17;
      font-size: 12px;
      color: #b2b2b2;
      margin: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue